import unleashBootstrap from '@server/feature-flags/unleash-bootstrap.json';
import type { FeatureFlags, FeatureFlagsKey } from './types';

export const FEATURE_FLAGS = {
	ELEMONOPY_TEST: 'ElemenopyTest',
	LISTINGS_PRICING: 'tk-listings-pricing',
	STOREFRONT_EMPTY_STATES: 'tk-storefront-bvc-plus-empty-states',
	LISTING_DEBUGGER: 'tk-listing-debugger',
	SEO_EXPERIMENTS: 'tk-seo-experiments',
	BLACK_FRIDAY_DEALS_ENABLED: 'tk-black-friday-deals-enabled',
	PRICE_ESTIMATOR: 'web-tk-price-estimator',
	TK_RFQ_TRACKING_ERRORS: 'tk-rfq-tracking-errors',
} as const;

export const getInitialState = (): FeatureFlags =>
	Object.values(FEATURE_FLAGS)?.reduce(
		(
			result: Record<FeatureFlagsKey, boolean>,
			featureFlag: FeatureFlagsKey,
		) => {
			result[featureFlag] =
				unleashBootstrap.features.find((f) => f.name === featureFlag)
					?.enabled || false;
			return result;
		},
		{} as FeatureFlags,
	) || {
		ElemenopyTest: false,
		'tk-listings-pricing': false,
		'tk-storefront-reviews-ai-summary': false,
		'tk-storefront-reviews-ai-summary-dc': false,
		'tk-storefront-bvc-plus-empty-states': false,
		'tk-listing-debugger': false,
		'tk-seo-experiments': false,
		'tk-black-friday-deals-enabled': false,
		'web-tk-price-estimator': false,
		'tk-rfq-tracking-errors': false,
	};
